import * as fromDatatype from '../datatype-library';

export interface bl_fi_generic_doc_line_xtn_doc_line_matching_balance_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  xtn_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  xtn_gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  xtn_gen_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  itn_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  itn_gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  itn_gen_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  doc_ccy: fromDatatype.CurrencyCodeDataFieldInterface;
  unit_price: fromDatatype.NumericDatatypeInterface;
  bal_qty: fromDatatype.NumericDatatypeInterface;
  bal_amt: fromDatatype.NumericDatatypeInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.RevisionDataFieldInterface;
}

export class bl_fi_generic_doc_line_xtn_doc_line_matching_balance_RowClass
  implements bl_fi_generic_doc_line_xtn_doc_line_matching_balance_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    xtn_server_doc_type: fromDatatype.VarcharDatatypeInterface;
    xtn_gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    xtn_gen_doc_line_guid: fromDatatype.GuidDataFieldInterface;
    itn_server_doc_type: fromDatatype.VarcharDatatypeInterface;
    itn_gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    itn_gen_doc_line_guid: fromDatatype.GuidDataFieldInterface;
    doc_ccy: fromDatatype.CurrencyCodeDataFieldInterface;
    unit_price: fromDatatype.NumericDatatypeInterface;
    bal_qty: fromDatatype.NumericDatatypeInterface;
    bal_amt: fromDatatype.NumericDatatypeInterface;
    namespace: fromDatatype.NamespaceDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.RevisionDataFieldInterface;
}
